document.addEventListener("DOMContentLoaded", () => {
  new Swiper(".image-carousel-section .swiper-container", {
    slidesPerView: 3.5,
    centeredSlides: true,
    spaceBetween: 20,
    initialSlide: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1440: {
        slidesPerView: 3.5,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2.3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
    },
  });

  let swipers = document.querySelectorAll('.simple-modal-swiper')
  swipers.forEach(s => {
    new Swiper(s, {
      slidesPerView: 2.5,
      spaceBetween: 20,
      //slide full 2.5 slides each time
      slidesPerGroup: 2,
      breakpoints: {
        1440: {
          slidesPerView: 3.5,
          spaceBetween: 20,
          slidesPerGroup: 2,
        },
        1024: {
          slidesPerView: 2.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 2,
        },
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      keyboard: {
        enabled: true,
      },
    });
  })


});